import { Component } from '@angular/core';

@Component({
  selector: 'cube-list-icon',
  templateUrl: 'cube-list-icon.html'
})
export class CubeListIconComponent {

 

  constructor() {
    console.log('Hello CubeListIconComponent Component');
    
  }

}



// WEBPACK FOOTER //
// ./src/components/cube-list-icon/cube-list-icon.ts